import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// "How private AI works" — resolves the apparent contradiction between
// "AI tags every link" and "we can't read your bookmarks" with specifics,
// not slogans. Claims here must stay in sync with the app: per-bookmark
// opt-in AES-GCM encryption on-device, and the app never sends a locked
// bookmark's plaintext anywhere (including the suggestion endpoint).
export const PrivateAI = () => {
  const { t } = useTranslation();

  const panels = [
    {
      icon: "bi-shield-lock",
      key: "encrypt",
    },
    {
      icon: "bi-stars",
      key: "boundary",
    },
    {
      icon: "bi-eye-slash",
      key: "visibility",
    },
  ];

  return (
    <section id="private-ai" className="container section-padding pb-0">
      <div className="row">
        <div className="col-xl-8 col-lg-10 mx-auto text-center mb-5">
          <p className="text-primary fw-semibold mb-2">
            {t("home.privateAI.badge", "Private by architecture, smart by design")}
          </p>
          <h2 className="display-5 fw-bold mb-3">
            {t("home.privateAI.title", "How private AI works")}
          </h2>
          <p className="lead mb-0">{t("home.privateAI.description")}</p>
        </div>
      </div>
      <div className="row g-4 align-items-stretch">
        {panels.map((panel) => (
          <div className="col-md-4" key={panel.key}>
            <div className="card border rounded-4 shadow-none p-4 h-100">
              <i className={`bi ${panel.icon} fs-3 text-primary mb-3`}></i>
              <h3 className="h5 fw-semibold mb-2">
                {t(`home.privateAI.${panel.key}.title`)}
              </h3>
              <p className="text-muted mb-0">
                {t(`home.privateAI.${panel.key}.description`)}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="text-center mt-4">
        <Link
          to="/features/encryption"
          className="btn btn-none text-primary p-0 d-inline-flex align-items-center gap-2"
        >
          {t("home.privateAI.link", "Read how encryption works")}
          <i className="bi bi-arrow-right"></i>
        </Link>
      </div>
    </section>
  );
};

export default PrivateAI;
